"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpItemList = exports.HelpMenu = void 0;
const phaser_1 = __importDefault(require("phaser"));
const ColorPalette_1 = require("../../constants/ColorPalette");
const EventConst_1 = require("../../constants/EventConst");
const TextureKeys_1 = require("../../constants/TextureKeys");
const ScrollCamera_1 = require("../../utils/ScrollCamera");
const Utils_1 = require("../../utils/Utils");
const HelpItem_1 = require("./HelpItem");
const Fonts_1 = require("../../constants/Fonts");
const FeedbackBox_1 = require("./FeedbackBox");
class HelpMenu extends phaser_1.default.GameObjects.Container {
    constructor(scene) {
        super(scene);
        this.helpItemList = [];
        this.helpListData = exports.HelpItemList.map((ele) => (Object.assign({}, ele)));
        this.buildHelpMenu();
        this.scene.events.on(EventConst_1.Events.RefreshHelpMenu, this.buildHelpMenu.bind(this));
        scene.add.existing(this);
    }
    buildHelpMenu() {
        this.renderList();
        this.renderTileSprite();
        this.renderBottomArea();
        this.makeScrollCamera();
    }
    /**
     * Render tile sprite background of menu
     */
    renderTileSprite() {
        var _a;
        const scale = Utils_1.Utils.scale;
        (_a = this.tileSprite) === null || _a === void 0 ? void 0 : _a.destroy();
        // Tile sprite
        this.tileSprite = this.scene.add.tileSprite(0, 0, 0, 0, TextureKeys_1.TextureKeys.HelpUI, 'tile');
        this.tileSprite.setOrigin(0, 0);
        this.tileSprite.setScale(scale);
        this.tileSprite.displayHeight =
            this.calculateListHeight() +
                30 * scale * (this.helpItemList.length - 1) +
                550 * scale;
        // Set interactive to avoid conflict with farm scene when scroll camera
        this.tileSprite.setInteractive();
    }
    /**
     * Render list of help item
     */
    renderList() {
        const scale = Utils_1.Utils.scale;
        if (this.helpItemList) {
            this.helpItemList.forEach((item) => item.destroy());
            this.helpItemList = [];
        }
        this.helpListData.forEach((item, index) => {
            let helpItem;
            if (index === 0) {
                helpItem = new HelpItem_1.HelpItem(this.scene, 160 * scale, item);
            }
            else {
                const startY = this.helpItemList[index - 1].shadow.getBottomCenter().y + 30 * scale;
                helpItem = new HelpItem_1.HelpItem(this.scene, startY, item);
            }
            this.helpItemList.push(helpItem);
        });
    }
    /**
     * Render bottom text & button
     */
    renderBottomArea() {
        var _a;
        const scale = Utils_1.Utils.scale;
        const gameWidth = this.scene.scale.width;
        (_a = this.feedbackBox) === null || _a === void 0 ? void 0 : _a.destroy();
        // Feedback box
        this.feedbackBox = new FeedbackBox_1.FeedbackBox(this.scene, gameWidth / 2, this.tileSprite.getBottomCenter().y - 388 * scale);
        this.renderHelpCenterText();
    }
    renderHelpCenterText() {
        const scale = Utils_1.Utils.scale;
        const gameWidth = this.scene.scale.width;
        // Help center line 1
        const textLine1 = this.scene.add
            .text(gameWidth / 2, this.tileSprite.getBottomCenter().y - 170 * scale, '問題解決できない場合は', {
            fontFamily: Fonts_1.Fonts.default,
            color: ColorPalette_1.ColorPalette.HelpButtonTitle,
            fontSize: `${25 * scale}px`,
            align: 'center',
            stroke: ColorPalette_1.ColorPalette.HelpButtonTitle,
            strokeThickness: 1,
        })
            .setOrigin(0.5);
        // Help center link
        const textLink = this.scene.add
            .text(gameWidth / 2, textLine1.y + 22, 'ヘルプセンター', {
            fontFamily: Fonts_1.Fonts.default,
            color: ColorPalette_1.ColorPalette.Primary,
            fontSize: `${25 * scale}px`,
            align: 'center',
            stroke: ColorPalette_1.ColorPalette.Primary,
            strokeThickness: 1,
        })
            .setInteractive({ cursor: 'pointer' });
        Utils_1.Utils.addClickEventToObject(this.scene, textLink);
        textLink.on('click', Utils_1.helpCenterClicked);
        // Help center last line
        const textLine2 = this.scene.add.text(textLink.getRightCenter().x, textLink.y, 'にお問い合わせください', {
            fontFamily: Fonts_1.Fonts.default,
            color: ColorPalette_1.ColorPalette.HelpButtonTitle,
            fontSize: `${25 * scale}px`,
            align: 'center',
            stroke: ColorPalette_1.ColorPalette.HelpButtonTitle,
            strokeThickness: 1,
        });
        // Align help center text to center
        const totalWidth = textLink.displayWidth + textLine2.displayWidth;
        textLink.setX(textLink.x - totalWidth / 2);
        textLine2.setX(textLine2.x - totalWidth / 2);
    }
    /**
     * Calculate height of list item
     */
    calculateListHeight() {
        let listHeight = 0;
        this.helpItemList.forEach((item) => {
            listHeight += item.shadow.displayHeight;
        });
        return listHeight;
    }
    /**
     * Scroll this scene depend on the length of item
     */
    makeScrollCamera() {
        const cameraOptions = {
            width: this.scene.scale.width,
            height: this.scene.scale.height,
            bottom: this.tileSprite.displayHeight + this.tileSprite.y,
            wheel: true,
        };
        this.scrollCamera = new ScrollCamera_1.ScrollingCamera(this.scene, cameraOptions);
        // keep scroll position of the previous camera.
        const prevCamera = this.scene.cameras.cameras[0];
        this.scrollCamera.scrollX = prevCamera.scrollX;
        this.scrollCamera.scrollY = prevCamera.scrollY;
        this.scene.cameras.cameras = [this.scrollCamera];
    }
}
exports.HelpMenu = HelpMenu;
//********************* Menu config  **************************/
exports.HelpItemList = [
    {
        question: '「シフォンとマフィンのはぐくまファーム」とはなんですか？',
        answer: [
            '「シフォンとマフィンのはぐくまファーム」は、マフィンや他の仲間たちと一緒に、シフォンを元気づける豊かな農場を目指すゲームです。',
            'ちょっとした休憩の合間など、マイペースにゆるるん生活をお楽しみください。',
        ],
        isOpen: false,
    },
    {
        question: '無料で遊べますか？',
        answer: [
            '「シフォンとマフィンのはぐくまファーム」は基本無料で遊べます。',
            '別途有料通貨を購入することで、ゲームに役に立てたり、ゲームをよりお楽しみいただけます。',
            '※データ通信料はお客様の負担となります。',
        ],
        isOpen: false,
    },
    {
        question: '対応端末や推奨環境は？',
        answer: [
            '「シフォンとマフィンのはぐくまファーム」の推奨環境は、「メニュー」内の「推奨環境」からご確認いただけます。',
        ],
        isOpen: false,
    },
    {
        question: 'ゲーム画面を操作できない状態から先へ進みません',
        answer: [
            'ゲームデータの読み込みがうまくできなかった可能性があります。',
            'ブラウザのページ更新（再読み込み）をお試しください。',
        ],
        isOpen: false,
    },
    {
        question: '機種変更をした場合、セーブデータはどうなりますか？',
        answer: [
            '「シフォンとマフィンのはぐくまファーム」のデータは「ワラウアカウント」に紐づいています。',
            'ご利用の端末が変わっても、「ワラウアカウント」にログインいただければ、以前のデータから引き続きプレイできます。',
            '　',
            'ただし、180日以上のご利用が見受けられない場合、データを削除しております。',
            'データを保持したい場合には、継続的なご利用をおすすめいたします。',
        ],
        isOpen: false,
    },
    {
        question: '久しぶりにログインしたら、データが消えておりLv.1からスタートしました',
        answer: [
            '「シフォンとマフィンのはぐくまファーム」では、180日以上ご利用が見受けられない場合、全てのデータを削除いたします。',
            'データ削除後に再利用した場合は、初期状態（Lv.1）から再スタートとなります。',
            '本件は、ゲーム全体のプレイ環境を整備するための取り組みとしております。',
            'データを保持したい場合には、継続的なご利用をおすすめいたします。',
            '　',
            '※ 削除データの復旧・途中再開はできません。',
            '※ 対応処理は、ワラウご利用規約 第6条7項目・第6条9項目に基づいております。',
        ],
        isOpen: false,
    },
    {
        question: 'もらった「いいね！」の数が減りました',
        answer: [
            '「シフォンとマフィンのはぐくまファーム」では、180日以上ご利用が見受けられないユーザーの全てのデータを削除しております。',
            'そのため、削除されたユーザー分の「いいね！」数が減ります。',
        ],
        isOpen: false,
    },
    {
        question: '日本国外からは遊べますか？',
        answer: ['海外からはご利用いただけません。'],
        isOpen: false,
    },
    {
        question: 'ネット環境がなくても遊べますか？',
        answer: [
            '「シフォンとマフィンのはぐくまファーム」は、ブラウザで遊ぶオンラインゲームです。オフライン環境でのプレイはできません。',
        ],
        isOpen: false,
    },
    {
        question: '何をすれば良いのかわかりません',
        answer: [
            '何をしようか迷った時は、「ミッション」のクリアを目標に農場生活をしてみましょう。',
            '期間限定で開催される「イベント」に参加するのもオススメです。ご自分のペースでプレイをお楽しみください。',
        ],
        isOpen: false,
    },
    {
        question: '「しょくぶつ」や「どうぶつ」の育て方がわかりません',
        answer: [
            '「しょくぶつ」や「どうぶつ」は、お世話をしなくても時間がたつと自然とすくすく育ち、収穫できます。',
            '成長途中で「水やり」や「エサあげ」のアイコンが出ている時に、それぞれお世話をすると収穫できる数が増加します。',
        ],
        isOpen: false,
    },
    {
        question: '畑やまきばはどこで入手できますか？',
        answer: [
            '「畑」や「まきば」は「ショップ・デ・キャロップ」で購入でき、ユーザーレベルアップに応じてショップの在庫に追加されます。',
            '経験値を貯めてレベルアップを目指しましょう。',
        ],
        isOpen: false,
    },
    {
        question: 'ユーザーレベルをアップするには？',
        answer: [
            'ユーザーレベルをアップするには、経験値が必要です。',
            '経験値は、育成アイテムの収穫や納品のお礼で獲得できます。',
        ],
        isOpen: false,
    },
    {
        question: '「水やり」や「エサあげ」ができる段階なのに、できないのはどうして？',
        answer: [
            'すでに「水やり」や「エサあげ」が完了している可能性があります。',
            '該当の「しょくぶつ」または「どうぶつ」を選択すると「成長ステータス」が表示され、お世話状況や収穫までの時間を確認できます。',
        ],
        isOpen: false,
    },
    {
        question: '育ちきった「しょくぶつ」や「どうぶつ」の調子が悪そうです',
        answer: [
            '収穫できるまで育ちきった「しょくぶつ」や「どうぶつ」は、一定期間収穫されずに放置されると、枯れたり病気になってしまいます。',
            '収穫できる状態には戻せません。',
            '「お掃除」や「お別れ」をして、畑やまきばをリセットしてから、新しい「しょくぶつ」や「どうぶつ」を育成しましょう。',
        ],
        isOpen: false,
    },
    {
        question: 'クラフトの材料が手に入りません',
        answer: [
            'クラフトの材料は、収穫しているときに時々「拾いもの」で入手できます。',
        ],
        isOpen: false,
    },
    {
        question: 'クラフト枠を増枠したい',
        answer: [
            'クラフト枠の増枠には、コロンで増枠する方法とジュエルで増枠する方法があります。',
            '必要ユーザーレベルに到達すると最大2回コロンで増枠できます。',
            'ジュエルで増枠する場合はレベル制限はなく、すぐに5枠目まで増枠することが可能です。',
        ],
        isOpen: false,
    },
    {
        question: '倉庫がいっぱいで、収穫ができません',
        answer: [
            '倉庫がいっぱいになったら、アイテムを「売却」したり、倉庫を「拡張」したりして、空きを確保しましょう。',
            'アイテムの「売却」はショップや倉庫からできます。',
            '倉庫の「拡張」にはジュエルを使用します。保管できる上限が増えるので、余裕を持ってアイテムが保管しやすくなりオススメです。',
        ],
        isOpen: false,
    },
    {
        question: '納品できる依頼書がありません',
        answer: [
            '納品できる依頼書がない場合は「依頼変更」ボタンを選択すると、他の依頼に変えられます。',
            '変更には少し時間がかかります。',
            'すぐに新しい依頼書が欲しい場合は、ジュエルを消費すれば、ピチタロがすぐに補充してくれます。',
        ],
        isOpen: false,
    },
    {
        question: '宅配ポストのアイテムが受け取っていないのになくなりました',
        answer: [
            '宅配ポストからアイテムが消える場合は、下記の要因が考えられます。復旧対応は行っておりませんのでご注意ください。',
            '・受け取り有効期限の切れたアイテムが消えた',
            '・宅配ポストの保管最大数100件を超えたので、宅配ポストに保管された古い日付のアイテムが溢れた',
        ],
        isOpen: false,
    },
    {
        question: '配置したアイテムをまた移動させたいです',
        answer: [
            '移動したいアイテムを2秒ほど長押しすると、個別配置モードになり、お好きな場所に移動できます。',
            '農場全体を模様替えしたい場合は、下部メニューにある「配置」ボタンを選択しましょう。「まとめて配置モード」になり、長押しせずにアイテムの移動ができるので、複数アイテムを動かしたいときに便利です。',
            '「自然」アイテムは一度配置すると移動できませんが、道具アイテムを使えば撤去できます。',
        ],
        isOpen: false,
    },
    {
        question: '農場の敷地を拡張したいです',
        answer: [
            '農場のエリアは、レベルアップに応じて拡張できるようになります。',
            'エリア拡張後は木や岩などの自然アイテムを撤去すると、デコや施設を配置できるようになります。',
        ],
        isOpen: false,
    },
    {
        question: '木や岩、花が動かせないです',
        answer: [
            'もともと農場に存在している木や岩などの「自然」アイテムは、移動させることができません。',
            'ショップ購入などで入手し、ご自身で配置した場合も、一度配置を決めると移動できません。',
            '動かしたい自然アイテムは、それぞれ専用の道具アイテムを使って撤去し、また新しくショップで購入したものを配置して、レイアウトをお楽しみください。',
        ],
        isOpen: false,
    },
    {
        question: 'ジュエルとはなんですか？',
        answer: [
            'ジュエルは「シフォンとマフィンのはぐくまファーム」のみで使用できる有料通貨です。',
            'ジュエルを使用することで、ゲームをさらにお楽しみいただけます。',
            'ワラウマネーから購入でき、有効期限は購入後（入手後）180日間です。',
            '※ジュエルはゲーム内にて無償で入手することもできます。',
        ],
        isOpen: false,
    },
    {
        question: 'ジュエルはどこで購入できますか？',
        answer: [
            'ジュエルは、「ジュエル所持数」の横にある「＋」ボタンをタップするか、「メニュー」>「ジュエルショップ」からご購入いただけます。',
        ],
        isOpen: false,
    },
    {
        question: 'ジュエルは無償で入手できますか？',
        answer: [
            'ユーザーレベルアップ時のプレゼントやミッションのクリア報酬などで手に入ることがあります。',
            '有効期限は入手後180日間です。',
        ],
        isOpen: false,
    },
    {
        question: 'ジュエルに有効期限はありますか？',
        answer: [
            'ジュエルの有効期限は、有償・無償問わず、購入後（入手後）180日間です。',
            '有効期限や利用履歴は、ジュエルショップ > 利用履歴 でご確認いただけます。',
        ],
        isOpen: false,
    },
    {
        question: 'ジュエルを間違って購入してしまいました',
        answer: [
            'ジュエルは一度購入が完了した場合、ワラウマネーへの払い戻し対応はできません。',
            '十分にご確認いただいてからご購入ください。',
        ],
        isOpen: false,
    },
    {
        question: 'ワラウマネーがなくてジュエルを購入できません',
        answer: [
            'ワラウマネーをチャージいただくことで、ジュエルをご購入いただけるようになります。',
            'ワラウマネーは、ジュエルショップ > ワラウマネー残高の「＋」ボタン > ワラウマネーチャージ よりご購入いただけます。',
        ],
        isOpen: false,
    },
    {
        question: '他のプレイヤーと遊べますか？',
        answer: [
            '現在該当する機能はありません。',
            '新機能としてリリースする際にお知らせいたしますので、今しばらくお待ちください。',
        ],
        isOpen: false,
    },
    {
        question: '他のプレイヤーの農場を見たいです',
        answer: [
            '画面左上にあるブーツアイコンの「おでかけメニュー」から他の農場を見に行けます。',
            '色々な農場を見てレイアウトの参考にしてみましょう。',
        ],
        isOpen: false,
    },
];
